/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconAlert16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconAlert16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="m7.334 9.334-.167-4h1.667l-.167 4H7.334ZM9 11.334a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.158 1.465a2.755 2.755 0 0 1 1.685 0c.582.188 1.01.625 1.4 1.155.385.526.806 1.253 1.331 2.157l2.22 3.826c.518.893.934 1.61 1.196 2.197.264.593.427 1.172.3 1.757-.121.55-.415 1.05-.841 1.426-.452.4-1.044.547-1.698.616-.648.068-1.486.068-2.53.068H5.78c-1.044 0-1.882 0-2.53-.068-.654-.069-1.246-.216-1.698-.616a2.665 2.665 0 0 1-.84-1.426c-.129-.585.035-1.164.299-1.757.261-.588.677-1.304 1.195-2.197l2.22-3.826c.526-.904.947-1.63 1.333-2.157.388-.53.817-.967 1.399-1.155Zm1.263 1.27a1.377 1.377 0 0 0-.842 0c-.164.054-.38.204-.72.667-.338.462-.724 1.126-1.274 2.074L3.405 9.23c-.543.936-.922 1.591-1.151 2.105-.23.517-.252.774-.216.94.06.275.208.524.42.713.128.113.366.221.935.281.568.06 1.334.06 2.428.06h4.359c1.094 0 1.86 0 2.427-.06.57-.06.807-.168.935-.281.213-.189.36-.438.42-.713.037-.166.015-.423-.215-.94-.23-.514-.608-1.17-1.151-2.105l-2.18-3.755c-.55-.948-.936-1.612-1.274-2.074-.34-.464-.557-.613-.72-.666Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconAlert24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconAlert24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="m11 14-.25-6h2.5L13 14h-2ZM13.5 17a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.737 2.198a4.132 4.132 0 0 1 2.526 0c.874.28 1.517.937 2.1 1.732.578.79 1.21 1.879 1.998 3.236l3.33 5.739c.777 1.338 1.4 2.413 1.793 3.295.396.89.641 1.758.45 2.636a3.997 3.997 0 0 1-1.261 2.138c-.679.6-1.566.821-2.547.924-.972.102-2.23.102-3.795.102H8.669c-1.565 0-2.823 0-3.795-.102-.98-.103-1.868-.324-2.547-.924a3.997 3.997 0 0 1-1.26-2.138c-.192-.878.053-1.747.449-2.636.392-.882 1.016-1.957 1.793-3.295l3.33-5.74C7.427 5.81 8.06 4.72 8.637 3.93c.584-.795 1.226-1.451 2.1-1.732Zm1.895 1.906a2.066 2.066 0 0 0-1.264 0c-.246.079-.57.303-1.08 1-.507.692-1.087 1.687-1.912 3.109l-3.269 5.634c-.814 1.403-1.383 2.386-1.727 3.158-.345.774-.377 1.16-.323 1.408.09.413.31.787.63 1.07.192.17.548.332 1.403.422.85.089 2 .09 3.64.09h6.54c1.64 0 2.79-.001 3.64-.09.855-.09 1.21-.253 1.403-.422.32-.283.54-.657.63-1.07.054-.248.022-.634-.323-1.409-.344-.771-.913-1.754-1.727-3.157l-3.27-5.634c-.824-1.422-1.404-2.417-1.911-3.11-.51-.696-.834-.92-1.08-1Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconAlert = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconAlert(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconAlert16 {...iconProps} />;
        case '24':
            return <IconAlert24 {...iconProps} />;
        default:
            return <IconAlert24 {...iconProps} />;
    }
});
